import { render, staticRenderFns } from "./view-dashboard.vue?vue&type=template&id=3d945b3b&"
import script from "./view-dashboard.vue?vue&type=script&lang=js&"
export * from "./view-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./view-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports